// Add your custom JS here.
( function( $ ) {

    AOS.init();




    // HEADER SCROLL FUNCTIONS
    $(document).scroll(function(){
        if($(this).scrollTop() > 700) {   
            $('.cta-button').addClass('off-top');

        }
        if($(this).scrollTop() < 700) {   
            $('.cta-button').removeClass('off-top');
        }
    });






    const caseSwiper = new Swiper('.case-swiper', {
        slidesPerView: 'auto', // Allows multiple slides to show in view based on their width
        navigation: {
            nextEl: '.case-swiper-next',
            prevEl: '.case-swiper-prev',
        },
        pagination: {
            el: '.case-swiper-pagination',
            type: 'fraction', // Display pagination in fraction format (e.g., 1 / 4)
            formatFractionCurrent: (number) => number, // Customize current slide format (e.g., show '1' instead of '01')
            formatFractionTotal: (number) => number, // Customize total slides format (e.g., show '4' instead of '04')
        },
        spaceBetween: 40, // Adjust space between slides if needed
        loop: false, // Enable looping to cycle through slides
    });



    const valueSwiper = new Swiper('.value-swiper', {
        slidesPerView: 'auto', // Allows multiple slides to show in view based on their width
        navigation: {
            nextEl: '.value-swiper-next',
            prevEl: '.value-swiper-prev',
        },
        pagination: {
            el: '.value-swiper-pagination',
            type: 'fraction', // Display pagination in fraction format (e.g., 1 / 4)
            formatFractionCurrent: (number) => number, // Customize current slide format (e.g., show '1' instead of '01')
            formatFractionTotal: (number) => number, // Customize total slides format (e.g., show '4' instead of '04')
        },
        spaceBetween: 40, // Adjust space between slides if needed
        loop: false, // Enable looping to cycle through slides
    });




    // HEADER MENU TOGGLE
    if ($(window).width() < 992) {
        $(".menu-toggle").on("click", function () {

            if (!$("#wrapper-navbar").hasClass("active")) {
                $("#wrapper-navbar").addClass('active');
                $("body").addClass('dropdown-active');
            } else {
                $("#wrapper-navbar").removeClass('active');
                $("body").removeClass('dropdown-active');
            }
        });

        $("#wrapper-navbar .wpml-ls").on("click", function () {
            $("body").toggleClass('dropdown-active');
        });
    
        $(".menu-item-has-children").on("click", function () {
            $(this).children(".sub-menu").slideToggle(150);
        });

        $('body').on('click', function(event) {
            // Check if the target of the click event is the body itself
            if (event.target === this) {
                $("body").removeClass("dropdown-active");
                $("#wrapper-navbar").removeClass('active');
            }
        });
    }






    //////// MENU TOGGLE
    $('.menu-toggle').on('click', function(e) {
        $(this).toggleClass("active");
        $("#wrapper-menu").toggleClass("active");
    });





    // SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {
        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });
    
    








    // PAGE TRANSITIONS
    $("a").click(function(event) {

        if ($(this).hasClass("notransition")) {
            return;
        }

        if ($(this).attr("target") === "_blank") {
            return;
        }

        var href = $(this).attr("href");
        if (href.startsWith("tel:") || href.startsWith("mailto:")) {
            return;
        }

        if (href.indexOf('#') !== -1) {
            return;
        }

        event.preventDefault();

        $(".page-transition-in").addClass("active");

        setTimeout(function() {
            window.location.href = href;
        }, 1000);
    });

    function removeActiveClass() {
        var element = document.querySelector('.page-transition-in');
        if (element) {
            element.classList.remove('active');
        }
    }

    window.addEventListener('load', removeActiveClass);
    window.addEventListener('pageshow', removeActiveClass);
    




    //// NEWS FILTERING
    $('.all').click(function() {
        // Uncheck all checkboxes
        $('#filter input[type="radio"]').prop('checked', false);
        $('#filter').trigger('change');
    });

    $('#filter input[type="radio"]').not('#all').click(function() {
        // Uncheck the "#all" checkbox
        $('#all').prop('checked', false);
    });




    $(".gform_footer").append("<i class='icon-arrow-topright primary500 branded'></i>");





    // PRODUCT TABS
    // if ($("body").hasClass("page-template-landingpage")) {

    //     $(".faq-item").on("click", function () {
    //         if (!$(this).hasClass("active")) {
    //             $(".faq-item.active .answer").slideUp(150);
    //             $(".faq-item.active").removeClass("active");
    //             $(this).addClass("active");
    //             $(this).children(".answer").slideDown(150);
    //         } else {
    //             $(this).removeClass("active");
    //             $(this).children(".answer").slideUp(150);
    //         }
    //     });
    // }




    gsap.registerPlugin(SplitText, ScrollTrigger);

    
    // TITLE FADE INS
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    document.querySelectorAll("h1, h2, h3").forEach((title) => {
        // Split text into words
        const split = new SplitText(title, { type: "words" });

        // Check if the title is in the viewport on page load
        const initialDelay = isInViewport(title) ? 0.3 : 0; // 300ms delay for titles in viewport

        // Apply GSAP animation with conditional delay
        gsap.fromTo(
            split.words,
            { opacity: 0, y: 20 },
            {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power4.out",
                stagger: 0.05,
                delay: initialDelay, // Set delay for elements initially in viewport
                scrollTrigger: {
                    trigger: title,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    onLeave: () => split.revert() // Clean up the split after animation
                }
            }
        );
    });





    // BACK PARALLAXES
    gsap.utils.toArray(".par-slow").forEach((image) => {
        gsap.fromTo(
            image,
            { y: -100 }, // Starting offset for the parallax effect
            {
                y: 100, // Ending offset
                ease: "none",
                scrollTrigger: {
                    trigger: image,
                    start: "top bottom", // Start when the image enters the viewport
                    end: "bottom top",   // End when the image leaves the viewport
                    scrub: true          // Smooth scrubbing for a nice parallax effect
                }
            }
        );
    });





    // BLOCK FADE INS
    gsap.utils.toArray(".block-link, .block, .case").forEach((block, index) => {
        gsap.fromTo(
            block,
            { opacity: 0, y: 20 }, // Initial state: invisible and slightly lower
            {
                opacity: 1,
                y: 0,
                duration: 0.6,        // Duration for each block's fade-in
                ease: "power2.out",   // Smooth easing effect
                delay: index * 0.1,   // 100ms delay per block based on index
                scrollTrigger: {
                    trigger: block,
                    start: "top 70%", // Trigger animation when block is near viewport
                    toggleActions: "play none none none" // Only plays once
                }
            }
        );
    });




    // PANELS FADE INS
    gsap.utils.toArray(".panelshape").forEach((block, index) => {
        gsap.fromTo(
            block,
            { opacity: 0, y: 100 }, // Initial state: invisible and slightly lower
            {
                opacity: 1,
                y: 0,
                duration: 0.6,        // Duration for each block's fade-in
                ease: "power2.out",   // Smooth easing effect
                delay: index * 0.2,   // 100ms delay per block based on index
                scrollTrigger: {
                    trigger: block,
                    start: "top 70%", // Trigger animation when block is near viewport
                    toggleActions: "play none none none" // Only plays once
                }
            }
        );
    });



    if ($(window).width() > 992) {

        gsap.utils.toArray(".followme").forEach((button) => {
            const threshold = 100; // Distance in pixels to start the effect from the element's edges

            // Listen for mousemove on the entire window
            window.addEventListener("mousemove", (event) => {
                const rect = button.getBoundingClientRect();

                // Calculate the distance from the cursor to the edges of the element
                const withinThreshold =
                    event.clientX > rect.left - threshold &&
                    event.clientX < rect.right + threshold &&
                    event.clientY > rect.top - threshold &&
                    event.clientY < rect.bottom + threshold;

                if (withinThreshold) {
                    // Calculate offset from the cursor to the element’s center for smooth movement
                    const x = event.clientX - (rect.left + rect.width / 2);
                    const y = event.clientY - (rect.top + rect.height / 2);

                    // Calculate movement factor based on proximity to threshold
                    const distanceToEdge = Math.min(
                        threshold,
                        Math.min(
                            Math.abs(event.clientX - rect.left),
                            Math.abs(event.clientX - rect.right),
                            Math.abs(event.clientY - rect.top),
                            Math.abs(event.clientY - rect.bottom)
                        )
                    );
                    const movementFactor = (threshold - distanceToEdge) / threshold; // A value between 0 and 1

                    // Apply GSAP animation for cursor-follow effect
                    gsap.to(button, {
                        x: x * 0.1 * movementFactor, // Adjust multiplier for smooth, subtle movement
                        y: y * 0.1 * movementFactor,
                        duration: 0.3,
                        ease: "power3.out"
                    });
                } else {
                    // Reset position if cursor moves outside the threshold
                    gsap.to(button, { x: 0, y: 0, duration: 0.3, ease: "power3.out" });
                }
            });
        });
    }




    ///// FAQ TOGGLE
    $(".faq-item").on("click", function () {
        if (!$(this).hasClass("active")) {
            $(".faq-item.active .answer").slideUp(150);
            $(".faq-item").removeClass("active");
            $(this).addClass("active");
            $(this).children(".answer").slideDown(150);
        } else {
            $(this).removeClass("active");
            $(this).children(".answer").slideUp(150);
        }
    });



    // GFORM BUTTONS    
    $(".gform_next_button, .gform_button").each(function () {
        $(this).wrap("<div class='button'></div>");
        $(this).parent().append("<i class='icon-arrow-topright primary500 branded'></i>");
    });



    const stickyElements = document.querySelectorAll('.service-category-dot');

    window.addEventListener('scroll', () => {
        stickyElements.forEach(element => {
            if (window.scrollY >= element.offsetTop) {
                element.classList.add('is-stuck');
            } else {
                element.classList.remove('is-stuck');
            }
        });
    });



    $(document).on('input', 'input[type="number"]', function() {
        // Remove any non-integer characters, including dots and commas
        this.value = this.value.replace(/[^0-9]/g, '');
    });
    
    $(document).on('keydown', 'input[type="number"]', function(event) {
        // Prevent the use of the "." and "," keys
        if (event.key === '.' || event.key === ',') {
            event.preventDefault();
        }
    });







    let canHide = false;

    // Enable hiding after 5 seconds
    setTimeout(() => {
        canHide = true;
    }, 5000);

    // Desktop scroll
    $(window).on('wheel', function(e) {
        if (canHide && e.originalEvent.deltaY > 0) {
            $('video, .logowrap, .intro-trigger, .view-two, .frontpage-footer, .frontpage-clients, .second-video').addClass('scrolled');
        }
    });

    // Mobile swipe
    let touchStartY = 0;

    $(window).on('touchstart', function(e) {
        touchStartY = e.originalEvent.touches[0].clientY;
    });

    $(window).on('touchmove', function(e) {
        if (!canHide) return;
        
        const touchY = e.originalEvent.touches[0].clientY;
        if (touchY - touchStartY > 50) {
            $('video, .logowrap, .intro-trigger, .view-two, .frontpage-footer, .frontpage-clients, .second-video').addClass('scrolled');
        }
    });


})(jQuery);



